// @ts-check
import React from 'react';
import QuickFillButton from '../QuickFillButton';

const NoteInput = ({ input, meta }) => {
  return (
    <div>
      <div>
        <textarea placeholder="Reminder note" className="input-large" {...input} />
        {meta && meta.touched && meta.error ? (
          <div style={{ color: 'rgb(244, 67, 54)' }}>{meta.error}</div>
        ) : null}
      </div>
      <div style={{ margin: '8px 0' }}>
        <QuickFillButton
          active={input.value === 'Call Office'}
          onClick={() => input.onChange('Call Office')}
        >
          Call Office
        </QuickFillButton>
        <QuickFillButton
          active={input.value === 'Call Patient'}
          onClick={() => input.onChange('Call Patient')}
        >
          Call Patient
        </QuickFillButton>
      </div>
    </div>
  );
};

export default NoteInput;
